/**
 * driftking.js — Mini DriftKing V2 bundle hero wiring.
 * Loaded as a classic theme asset AFTER driftking-core.js.
 *
 * Flow:
 *  - quantity radios (1/2/3) pick how many units are in the order
 *  - up to 3 per-unit color selects (data-dk-color), each an INDEPENDENT color
 *    whose value is a REAL variant id from product.variants
 *  - totals/compare/save% recomputed from the SELECTED variants (never hardcoded)
 *  - BUY NOW POSTs aggregated lines to /cart/add.js then navigates to checkout;
 *    busy guard prevents double submit, sold-out surfaces a status message.
 *  - a selected variant's featured image is driven in the gallery
 *  - ?variant= in the URL is preserved when valid
 *
 * Stable QA selectors come from DriftKingCore.ALL_VARIANTS_SELECTORS.
 */
(function () {
  'use strict';
  var S = (window.DriftKingCore || {}).ALL_VARIANTS_SELECTORS || {
    root: '[data-dk-root]',
    quantity: '[data-dk-quantity]',
    color: '[data-dk-color]',
    buy: '[data-dk-buy]',
    total: '[data-dk-total]',
    productJson: '[data-dk-product-json]',
    gallery: '[data-dk-gallery]',
    thumb: '[data-dk-thumb]',
    status: '[data-dk-status]',
  };

  function money(cents) {
    var cur = (window.__dkConfig && window.__dkConfig.currency) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format((cents || 0) / 100);
    } catch (_) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function config() {
    return window.__dkConfig || {};
  }

  function readProductJson() {
    var node = document.querySelector(S.productJson);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (_) {
      return null;
    }
  }

  function parseUrlVariant() {
    var m = /[?&]variant=(\d+)/.exec(window.location.search || '');
    return m ? m[1] : null;
  }

  function heroEl() {
    return document.querySelector(S.root);
  }

  function currentQuantity(hero) {
    var checked = hero.querySelector(S.quantity + ':checked');
    return Math.max(1, Math.min(3, Number(checked && checked.value) || 1));
  }

  /** The color selects that count toward the order (only the first `qty`). */
  function activeColorSelects(hero) {
    var qty = currentQuantity(hero);
    return [].slice.call(hero.querySelectorAll(S.color)).slice(0, qty);
  }

  function selectedColorIds(hero) {
    return activeColorSelects(hero).map(function (s) { return Number(s.value); });
  }

  function refreshTotals(hero, product, cartable) {
    var totalEl = hero.querySelector(S.total);
    var compareEl = hero.querySelector('[data-dk-compare]');
    var saveEl = hero.querySelector('[data-dk-save]');
    refreshBundleCards(hero, product, cartable);
    if (!totalEl) return;
    var t = cartable.computeTotals(product, selectedColorIds(hero));
    totalEl.textContent = money(t.price);
    if (compareEl) {
      compareEl.textContent = t.compare > t.price ? money(t.compare) : '';
      compareEl.style.display = t.compare > t.price ? '' : 'none';
    }
    if (saveEl) {
      saveEl.textContent = t.savePct > 0 ? 'SAVE ' + t.savePct + '%' : '';
      saveEl.style.display = t.savePct > 0 ? '' : 'none';
    }
  }

  /** Show/hide the per-unit rows beyond the chosen quantity. */
  function syncUnitVisibility(hero) {
    var qty = currentQuantity(hero);
    var units = hero.querySelector('[data-dk-units]');
    var host = hero.querySelector('[data-dk-unit-host="' + qty + '"]');
    if (units && host) { host.appendChild(units); units.hidden = qty === 1; }
    [].slice.call(hero.querySelectorAll('[data-dk-bundle]')).forEach(function(card){card.classList.toggle('is-selected',Number(card.dataset.dkBundle)===qty);});
    [].slice.call(hero.querySelectorAll('[data-dk-unit-row]')).forEach(function (row, i) {
      var on = i < qty;
      row.style.display = on ? '' : 'none';
      var sel = row.querySelector(S.color);
      if (sel) sel.disabled = !on;
    });
    if (hero.querySelector('[data-dk-units]')) {
      hero.querySelector('[data-dk-units]').setAttribute('data-qty', String(qty));
    }
  }

  function showStatus(hero, msg) {
    var st = hero.querySelector(S.status);
    if (!st) return;
    st.textContent = msg || '';
    st.hidden = !msg;
  }

  function syncGallery(hero, product, cartable, variantId) {
    var gal = hero.querySelector(S.gallery);
    if (!gal) return;
    var idx = cartable.getSlideIndex(product, variantId);
    if (idx < 0) return;
    if (typeof gal.dkShow === 'function') gal.dkShow(idx);
    var thumbs = [].slice.call(gal.querySelectorAll(S.thumb));
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    var slides = [].slice.call(gal.querySelectorAll('[data-dk-slide]'));
    slides.forEach(function (s, i) {
      var v = s.querySelector('video');
      if (v && i !== idx) { try { v.pause(); } catch (_) {} }
    });
  }

  function wireColorChanges(hero, product, cartable) {
    [].slice.call(hero.querySelectorAll(S.color)).forEach(function (sel) {
      sel.addEventListener('change', function () {
        syncModelState(hero, product, Number(sel.value), sel === hero.querySelector(S.color));
        refreshTotals(hero, product, cartable);
        syncGallery(hero, product, cartable, Number(sel.value));
      });
    });
  }

  function syncModelState(hero, product, id, update) {
    if (!update) return;
    var variant = product.variants.find(function(v){return Number(v.id)===Number(id);});
    if (!variant) return;
    var title=hero.querySelector('[data-dk-model-name]');if(title)title.textContent=variant.title;
    [].slice.call(hero.querySelectorAll('[data-dk-model]')).forEach(function(btn){btn.setAttribute('aria-pressed',String(Number(btn.dataset.dkModel)===Number(id)));});
  }
  function refreshBundleCards(hero, product, cartable) {
    var base=Number(hero.querySelector(S.color)?.value);
    [].slice.call(hero.querySelectorAll('[data-dk-bundle]')).forEach(function(card){
      var qty=Number(card.dataset.dkBundle);
      var ids=qty===currentQuantity(hero)?selectedColorIds(hero):Array(qty).fill(base);
      var total=cartable.computeTotals(product,ids);
      card.querySelector('[data-dk-bundle-price]').textContent=money(total.price);
      var compare=card.querySelector('[data-dk-bundle-compare]');compare.textContent=total.compare>total.price?money(total.compare):'';
      card.querySelector('[data-dk-bundle-saving]').textContent=total.save>0?'You save '+money(total.save):qty+' '+(qty===1?'car':'cars');
    });
  }
  function wireModelPicker(hero, product, cartable) {
    [].slice.call(hero.querySelectorAll('[data-dk-model]')).forEach(function(btn){
      btn.addEventListener('click',function(){
        [].slice.call(hero.querySelectorAll(S.color)).forEach(function(sel){sel.value=btn.dataset.dkModel;});
        syncModelState(hero,product,Number(btn.dataset.dkModel),true);
        refreshTotals(hero,product,cartable);
        syncGallery(hero,product,cartable,Number(btn.dataset.dkModel));
      });
    });
  }

  function wireQuantity(hero, product, cartable) {
    [].slice.call(hero.querySelectorAll(S.quantity)).forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          syncUnitVisibility(hero);
          refreshTotals(hero, product, cartable);
        }
      });
    });
  }

  /** Populate each color select with real variant ids (dynamic from product variants). */
  function populateOptions(hero, product) {
    var opts = (product.variants || []).map(function (v) {
      return '<option value="' + v.id + '">' + (v.option1 || v.title || v.id) + '</option>';
    }).join('');
    [].slice.call(hero.querySelectorAll(S.color)).forEach(function (sel) {
      sel.innerHTML = opts;
    });
  }

  function submit(hero, product, cartable, navigateCheckout) {
    var buyBtn = hero.querySelector(S.buy);
    var items = cartable.aggregateItems(selectedColorIds(hero));
    if (!items.length) {
      showStatus(hero, 'Please select a color.');
      return Promise.resolve();
    }
    // sold-out guard: any selected variant unavailable
    for (var i = 0; i < items.length; i++) {
      var v = cartable.variantById(product, items[i].id);
      if (v && v.available === false) {
        showStatus(hero, 'Selected color is sold out. Please choose another.');
        return Promise.resolve(false);
      }
    }
    if (buyBtn) buyBtn.disabled = true;
    showStatus(hero, '');
    var cfg = config();
    return (cfg.fetch || window.fetch)(cfg.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (d) { return { ok: res.ok, d: d }; }); })
      .then(function (out) {
        if (!out.ok || out.d.status) {
          showStatus(hero, (out.d && (out.d.description || out.d.message)) || 'Could not add to cart.');
          return false;
        }
        if (navigateCheckout) {
          var target = cfg.checkoutUrl || '/checkout';
          if (typeof cfg.navigate === 'function') {
            cfg.navigate(target); // tests: capture navigation target
          } else {
            window.location.assign(target);
          }
        } else {
          showStatus(hero, 'Added to cart.');
        }
        return true;
      })
      .catch(function () {
        showStatus(hero, 'Something went wrong. Please try again.');
        return false;
      })
      .finally(function () {
        if (buyBtn) buyBtn.disabled = false;
      });
  }

  function wireBuy(hero, product, cartable) {
    var busy = false;
    var form = document.querySelector('[data-dk-form]') || hero;
    var run = function (e) {
      if (e) e.preventDefault();
      if (busy) return; // prevent double submit
      busy = true;
      submit(hero, product, cartable, true).finally(function () {
        window.setTimeout(function () { busy = false; }, 0);
      });
    };
    form.addEventListener('submit', run);
    var buyBtn = hero.querySelector(S.buy);
    if (buyBtn) buyBtn.addEventListener('click', run);
    var addBtn = hero.querySelector('[data-dk-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (busy) return;
        busy = true;
        submit(hero, product, cartable, false).finally(function () {
          window.setTimeout(function () { busy = false; }, 0);
        });
      });
    }
    var sticky = document.querySelector('[data-dk-sticky-scroll]');
    if (sticky) {
      sticky.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector('#dk-offers');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function wireAutoplay() {
    var videos = [].slice.call(document.querySelectorAll('[data-dk-root] video, [data-dk-lazy-video]'));
    var visibility = new Map();
    function update(video) {
      if (document.hidden || !visibility.get(video)) { video.pause(); return; }
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () { /* Native controls remain as fallback. */ });
    }
    var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {visibility.set(entry.target,entry.isIntersecting && entry.intersectionRatio >= 0.2);update(entry.target);});
    }, {threshold:[0,0.2]}) : null;
    videos.forEach(function(video) {
      video.muted = true; video.defaultMuted = true;
      video.autoplay = true; video.loop = true; video.playsInline = true;
      if(observer)observer.observe(video);else {visibility.set(video,true);update(video);}
    });
    document.addEventListener('visibilitychange',function(){videos.forEach(update);});
  }

  function init() {
    var hero = heroEl();
    var product = readProductJson();
    if (!hero || !product || !window.DriftKingCore || hero.dataset.dkInitialized) return;
    hero.dataset.dkInitialized = 'true';
    wireGalleryNav(hero);
    var cartable = window.DriftKingCore;
    populateOptions(hero, product);
    syncUnitVisibility(hero);
    refreshTotals(hero, product, cartable);
    wireModelPicker(hero, product, cartable);
    wireColorChanges(hero, product, cartable);
    wireQuantity(hero, product, cartable);
    // preserve ?variant=
    var urlVariant = parseUrlVariant();
    if (urlVariant) {
      var ids = (product.variants || []).map(function (v) { return v.id; });
      if (ids.includes(Number(urlVariant))) {
        var first = hero.querySelector(S.color);
        if (first) {
          first.value = String(Number(urlVariant));
          first.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    wireSticky(hero);
    wireBuy(hero, product, cartable);
    wireAutoplay();
  }

  /** Gallery arrows + clicking a thumb shows that slide. */
  function wireGalleryNav(hero) {
    var viewport = hero.querySelector('[data-dk-viewport]');
    var thumbs = [].slice.call(hero.querySelectorAll(S.thumb));
    var prev = hero.querySelector('[data-dk-gal-prev]');
    var next = hero.querySelector('[data-dk-gal-next]');
    if (!viewport || !thumbs.length) return;
    var active = 0;
    var slides = [].slice.call(viewport.querySelectorAll('[data-dk-slide]'));
    function resizeFrame(index) {
      var video = slides[index] && slides[index].querySelector('video');
      viewport.style.aspectRatio = video && video.videoWidth ? video.videoWidth + ' / ' + video.videoHeight : '1 / 1';
    }
    slides.forEach(function(slide,index){
      var video=slide.querySelector('video');
      if(video)video.addEventListener('loadedmetadata',function(){if(index===active)resizeFrame(index);});
    });
    viewport.addEventListener('scroll',function(){
      var index=Math.round(viewport.scrollLeft / viewport.clientWidth);
      if(index!==active){active=index;resizeFrame(active);}
    },{passive:true});
    function show(i) {
      active = Math.max(0, Math.min(thumbs.length - 1, i));
      resizeFrame(active);
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === active); });
      [].slice.call(viewport.querySelectorAll('[data-dk-slide]')).forEach(function(slide,n){ var video=slide.querySelector('video'); if(video && n!==active)video.pause(); });
      if (viewport.scrollTo) {
        viewport.scrollTo({ left: active * viewport.clientWidth, behavior: 'smooth' });
      }
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === thumbs.length - 1;
    }
    hero.querySelector(S.gallery).dkShow = show;
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });
    if (prev) prev.addEventListener('click', function () { show(active - 1); });
    if (next) next.addEventListener('click', function () { show(active + 1); });
  }

  /** Sticky bar appears once the offer block scrolls out of view; its CTA only
   *  scrolls back to the offers — it never submits/buys early. */
  function wireSticky(hero) {
    var sticky = hero.querySelector('[data-dk-sticky]');
    var offers = hero.querySelector('#dk-offers') || hero.querySelector('[data-dk-offers]');
    if (!sticky || !offers || !window.IntersectionObserver) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = e && !e.isIntersecting && e.boundingClientRect.bottom < 0;
      sticky.classList.toggle('is-visible', !!show);
      sticky.setAttribute('aria-hidden', String(!show));
    }).observe(offers);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { init: init, money: money };
  }
  // expose for tests / section re-renders
  if (typeof window !== 'undefined') window.__dkInit = init;
})();
